import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { createStructuredSelector } from 'reselect';
import { translate } from 'react-i18next';
import Helmet from 'react-helmet';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

import config from 'config';
import i18n, { lngs } from 'i18n';
import { loadSiteConfig, loadProfile, logout, loadCountries, loadBikeTypes, loadExtraItemTypes } from 'actions';
import { createPromise, createDefaultPromise, buildHead } from 'utils';
import { configSelector, countriesSelector, bikeTypesSelector, extraItemTypesTypesSelector } from 'selectors';
import Header from 'components/Header';
import Footer from 'components/Footer';
import TravelPayoutPixel, { setTravelPayoutsCookie, getTravelPayoutsSubId } from 'widgets/TravelPayouts';
import { redirect } from 'widgets/I18nLink';
import Tawk from 'widgets/Tawk';

class App extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      travelPayoutsId: null
    };
  }

  componentDidMount() {
    this.getTravelPayoutsId();

    this.props.loadProfile()
      .then(action => {
        const isProfilePath = /^\/\w{2}\/profile/.test(this.props.location.pathname);

        if (isProfilePath && !(action.response && action.response.id)) {
          redirect('/');
        }

        return action;
      });
  }

  getTravelPayoutsId() {
    let travelPayoutsId = null;

    const query = this.props.location.query;
    if (query && query.utm_source === 'travelpayouts') {
      travelPayoutsId = query.sub_id || null;
      setTravelPayoutsCookie(travelPayoutsId);
    } else {
      travelPayoutsId = getTravelPayoutsSubId();
    }

    this.setState({ travelPayoutsId });
  }

  render() {
    const { t, siteConfig, location } = this.props;

    return (
      <div className="app">
        <Helmet {...buildHead(t, i18n.language, lngs, siteConfig, config.appProtocol, config.appDomain, location)} />

        <Header
          location={location}
          user={this.props.user}
          onLogout={this.props.logout}
        />

        <div className="page-container">
          {this.props.children}
        </div>

        {!!this.state.travelPayoutsId && (
          <TravelPayoutPixel pathname={location.pathname} />
        )}

        <Footer
          config={siteConfig}
          location={location}
        />

        <Tawk />
      </div>
    );
  }
}

const userProfileSelector = state => state.profile.profile;

const mapStateToProps = createStructuredSelector({
  siteConfig: configSelector,
  user: userProfileSelector
});

export default asyncConnect(
  [
    { promise: ({ store }) => createPromise(store, true, configSelector, loadSiteConfig) },
    { promise: createDefaultPromise(countriesSelector, loadCountries) },
    { promise: createDefaultPromise(bikeTypesSelector, loadBikeTypes) },
    { promise: createDefaultPromise(extraItemTypesTypesSelector, loadExtraItemTypes) }
  ],
  mapStateToProps,
  { loadProfile, logout }
)(
  translate(['meta'], { wait: false })(App)
);



// WEBPACK FOOTER //
// ./src/App.js